export default "query Health {\n  health\n}\n"